<template>
  <div class="container max-w-4xl mx-auto">
    <LView :useMargins="false">
      <template #body>
        <div class="title mt-20 flex items-center justify-center text-6xl font-bold font-header">
          <h1>Partners</h1>
        </div>
        <div class="SectionHero">


          <div
              v-for="(data, i) in myData"
              :key="i"
              class="Section w-full mt-14 shadow"
          >
            <!--            <div class="flex justify-between w-full gap-8">-->
            <!--              <div class="logo flex h-64 justify-start items-center">-->
            <!--                <img class="w-[200px]" :src="data.brandImg" alt="logo"/>-->
            <!--              </div>-->
            <!--              <div class="body grow">-->
            <!--                <div class="flex flex-col justify-between h-full items-start">-->
            <!--                  <div class="title text-right font-semibold text-xl w-full p-4">-->
            <!--                    {{ data.univ }}-->
            <!--                  </div>-->
            <!--                  <div class="people p-4 self-end w-80 flex flex-col items-start">-->

            <!--                    <div class="person flex items-center">-->
            <!--                      <img-->
            <!--                          :src="data.personOneImg"-->
            <!--                          alt=""-->
            <!--                          class="rounded-full h-[100px]"-->
            <!--                      />-->

            <!--                      <div class="name ml-6">-->
            <!--                        <p class="font-semibold text-xl">{{ data.personOneName }}</p>-->
            <!--                      </div>-->

            <!--                    </div>-->
            <!--                    <div-->
            <!--                        v-if="data.personTwoImg"-->
            <!--                        class="person flex items-center"-->
            <!--                    >-->
            <!--                      <img-->
            <!--                          :src="data.personTwoImg"-->
            <!--                          alt=""-->
            <!--                          class="rounded-full h-[100px]"-->
            <!--                      />-->
            <!--                      <div class="name ml-4">-->
            <!--                        <p class="font-semibold text-xl">{{ data.personTwoName }}</p>-->
            <!--                      </div>-->
            <!--                    </div>-->
            <!--                  </div>-->


            <!--                </div>-->

            <!--              </div>-->

            <!--            </div>-->
            <p
                v-if="
                                  data.id === 1 ||
                                  data.id === 4 ||
                                  data.id === 6 ||
                                  data.id === 14
                                "
                class="h-10 bg-standardization/50 flex items-center justify-center text-white font-semibold text-lg k1:my-0"
            >
              {{ data.box }}
            </p>
            <div class="flex flex-col h6:flex-row justify-between w-full gap-8">
              <div class="left flex flex-col justify-between pl-6 items-start">
                <h3 class="font-semibold text-3xl pt-2 px-2 k1:px-0">{{ data.univ }}</h3>
                <div class="flex grow justify-between items-center w-full gap-4">
                  <img class="max-h-24 my-6" :src="data.brandImg" alt=""/>
                </div>
              </div>
              <div
                  class="people p-4 !w-80 h-full flex flex-col gap-4"
                  style="min-width: 320px;"
              >

                <div class="person flex items-center">
                  <img
                      :src="data.personOneImg"
                      alt=""
                      class="rounded-full h-[100px]"
                  />

                  <div class="name ml-6">
                    <p class="font-semibold text-xl">{{ data.personOneName }}</p>
                  </div>

                </div>
                <div
                    v-if="data.personTwoImg"
                    class="person flex items-center"
                >
                  <img
                      :src="data.personTwoImg"
                      alt=""
                      class="rounded-full h-[100px]"
                  />
                  <div class="name ml-4">
                    <p class="font-semibold text-xl">{{ data.personTwoName }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </template>
    </LView>
  </div>
</template>

<script>
import {reactive} from "vue";
import LView from "@/components/layout/LView.vue";

export default {
  name: "Partners",
  components: {
    LView,
  },
  setup() {
    const myData = reactive([
      {
        id: 1,
        univ: "Aarhus University",
        brandImg: require('@/assets/images/Aarhus_University_logo.svg.a8533700.png'),
        box: "Coordinator, WP1, WP5 Lead",
        personOneImg: require('@/assets/images/JacobSherson.6c01a10c.png'),
        personOneName: "Jacob Sherson",
        personTwoImg: require('@/assets/images/simon.14a29304.jpg'),
        personTwoName: "Simon Richard Goorney",
      },
      {
        id: 2,
        univ: "ICFO – The Institute of Photonic Sciences",
        brandImg: require('@/assets/images/ICFO-01.e530bc65.png'),
        personOneImg: require('@/assets/images/RobSewellStudio.80fc0a4e.jpeg'),
        personOneName: "Robert Sewell",
      },
      {
        id: 3,
        univ: "ICN2: Catalan Institute of Nanoscience and Nanotechnology",
        brandImg: require('@/assets/images/logo_ICN2.56ac0f26.png'),
        personOneImg: require('@/assets/images/JoseH_ICN2.7b97ef68.jpg'),
        personOneName: "Jose Hugo Garcia",
      },
      {
        id: 4,
        univ: "Czech Technical University in Prague",
        brandImg: require('@/assets/images/CTU.png'),
        personOneImg: require('@/assets/images/gabris.jpg'),
        personOneName: "Aurel Gabris",
        box: "WP2 Lead",
      },
      {
        id: 5,
        univ: "Copenhagen University",
        brandImg: require('@/assets/images/ku_co_uk_h.c02e5164.jpg'),
        personOneImg: require('@/assets/images/Jan Philip Solovej.jpg'),
        personOneName: "Jan Philip Solovej",
        personTwoImg: require('@/assets/images/Louise_Kindt.jpeg'),
        personTwoName: "Louise Kindt",
      },

      {
        id: 6,
        univ: "University of Jena",
        box: "WP3 Lead",
        brandImg: require('@/assets/images/LogoUniJena.png'),
        personOneImg: require('@/assets/images/martin_gaerttner.png'),
        personOneName: "Martin Gaerttner",
      },
      {
        id: 7,
        univ: "Science Melting Pot",
        brandImg: require('@/assets/images/SMP_transparent.6cb95fdc.png'),
        personOneImg: require('@/assets/images/Shaeema_SMP.31bbb65c.jpeg'),
        personOneName: "Shaeema Zaman",
      },
      {
        id: 8,
        univ: "University of Paris-Saclay",
        brandImg: require('@/assets/images/UPS1.11123733.png'),
        personOneImg: require('@/assets/images/marino.png'),
        personOneName: "Marino Marsi",
      },
      {
        id: 9,
        univ: "Centrale Supelec",
        brandImg: require('@/assets/images/ecole-centrale-supelec-logo-0B3865DB96-seeklogo.com.714255f6.png'),
        personOneImg: "data:image/png;base64,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",
        personOneName: "N. A.",
      },
      {
        id: 10,
        univ: "École Normale Supérieure of Paris",
        brandImg: require('@/assets/images/logo_ENS_-_PSL.c44f9940.png'),
        personOneImg: require('@/assets/images/Tarik Yefsah.4d822f58.jpg'),
        personOneName: "Tarik Yefsah",
      },
      {
        id: 11,
        univ: "University of Barcelona",
        brandImg: require('@/assets/images/UBarcelona.png'),
        personOneImg: require("@/assets/images/bruno2023.jpg"),
        personOneName: "Bruno Julia-Diaz",
      },
      {
        id: 12,
        univ: "University of Pisa",
        brandImg: require('@/assets/images/marchio_unipi_pant541_288.gif'),
        personOneImg: require('@/assets/images/IMG_5233.f3bdbf9a.jpg'),
        personOneName: "Marilu Chiofalo",
      },
      {
        id: 13,
        univ: "RWTH Aachen University",
        brandImg: require('@/assets/images/logo_rwth_rgb.70c054eb.png'),
        personOneImg: require('@/assets/images/20221129_DIGIQ_Final-09078.b03e4b82.jpeg'),
        personOneName: "Lisa Otten",
      },
      {
        id: 14,
        univ: "Ludwig Maximilian University of Munich",
        brandImg: require('@/assets/images/LMU_Logo_CMYK_FlaechigGruen.edde7749.png'),
        box: "WP4 Lead",
        personOneImg: require('@/assets/images/Kuhn.45600d1d.jpg'),
        personOneName: "Jochen Kuhn",
        personTwoImg: require('@/assets/images/Küchemann.34cdd35a.jpg'),
        personTwoName: "Stefan Kücheman",
      },
      {
        id: 15,
        univ: "University of Strasbourg",
        brandImg: require('@/assets/images/Signature_Universite_Strasbourg_Unistra2_Transparent.8b808efb.png'),
        personOneImg: require('@/assets/images/Shannon.jpeg'),
        personOneName: "Shannon Whitlock",
      },
      {
        id: 16,
        univ: "University of Helsinki",
        brandImg: require('@/assets/images/UH_logo_black.e4f8dc63.png'),
        personOneImg: require('@/assets/images/Tapio.jpeg'),
        personOneName: "Tapio Rasa",
        personTwoImg: require('@/assets/images/Caterina.jpeg'),
        personTwoName: "Caterina Foti",
      },
      {
        id: 17,
        univ: "Autonomous University of Barcelona",
        brandImg: require('@/assets/images/uab_logo.png'),
        personOneImg: require('@/assets/images/John_pict.1f07f040.jpg'),
        personOneName: "John Calsamiglia Costa",
      },
      {
        id: 18,
        univ: "Technische Universität München",
        brandImg: require('@/assets/images/TUM.100527f1.png'),
        personOneImg: require('@/assets/images/holleitner_small.44d05202.jpg'),
        personOneName: "Alexander Holleitner",
      },
      {
        id: 19,
        univ: "Quarks Interactive",
        brandImg: require('@/assets/images/QI-full-dark.2697daa6.png'),
        personOneImg: require('@/assets/images/Laur.jpeg'),
        personOneName: "Laurentiu Nita",
      },
      {
        id: 20,
        univ: "University of Technology of Troyes",
        brandImg: require('@/assets/images/utt.png'),
        personOneImg: require('@/assets/images/Christophe.png'),
        personOneName: "Christophe Couteau",
      },
      {
        id: 21,
        univ: "Sorbonne University",
        brandImg: require('@/assets/images/LOGO_SU.fbff7e69.jpg'),
        personOneImg: require('@/assets/images/Clement Sayrin.3e10e155.jpg'),
        personOneName: "Clement Sayrin",
      },
      {
        id: 22,
        univ: "Portuguese Quantum Institute",
        brandImg: require('@/assets/images/PQI.d7e53484.png'),
        personOneImg: require('@/assets/images/Joao Seixas.1bbefb03.jpeg'),
        personOneName: "Joao Seixas",
      },
      {
        id: 24,
        univ: "Instituto Superior Técnico",
        brandImg: require('@/assets/images/IST_A_RGB_POS.663cb8ee.png'),
        personOneImg: require('@/assets/images/Yasser Omar.a1d34458.jpg'),
        personOneName: "Yasser Omar",
      },
      {
        id: 25,
        univ: "Deloitte Portugal",
        brandImg: require('@/assets/images/Deloitte_black.png'),
        personOneImg: require('@/assets/images/mario.jpg'),
        personOneName: "Mario Caldeira",
        personTwoImg: require('@/assets/images/joao2.png'),
        personTwoName: "Joao Sabino",
      },
      {
        id: 26,
        univ: "Technical University of Denmark",
        brandImg: require('@/assets/images/DTU.png'),
        personTwoImg: require('@/assets/images/JonatanBohrBrask.png'),
        personTwoName: "Jonatan Bohr Brask",
        personOneImg: require('@/assets/images/Louise_Kindt.jpeg'),
        personOneName: "Louise Kindt",
      },
      {
        id: 27,
        univ: "Technische Universität Wien",
        brandImg: require('@/assets/images/TU_Wien.png'),
        personOneImg: require('@/assets/images/sabine.png'),
        personOneName: "Sabine Andergassen",
      },
      {
        id: 28,
        univ: "University of Latvia",
        brandImg: require('@/assets/images/latvia.png'),
        personOneImg: require('@/assets/images/abuzer.jpeg'),
        personOneName: "Abuzer Yakaryilmaz",
      },
    ]);

    return {
      myData,
    };
  },
};
</script>
